import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface SchedulingLinkWarningTextProps {}

/*
 * Style.
 */

const StyledWarningWrapperDiv = styled.div`
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.palette.red.shade40};
  line-height: 16px;
`;

/*
 * Component.
 */

export const SchedulingLinkWarningText: FC<SchedulingLinkWarningTextProps> = (props) => (
  <StyledWarningWrapperDiv>{props.children}</StyledWarningWrapperDiv>
);
